/* eslint-disable import/no-unresolved */
const home = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home'),
    children: [
      {
        path: 'my-invitation',
        name: 'MyInvitation',
        component: () =>
          import(/* webpackChunkName: "my-invitation" */ '@/views/home/MyInvitation'),
      },
      {
        path: 'project-info',
        name: 'ProjectInfo',
        component: () => import(/* webpackChunkName: "project-info" */ '@/views/home/ProjectInfo'),
      },
      {
        path: 'projects',
        name: 'Projects',
        component: () => import(/* webpackChunkName: "projects" */ '@/views/home/Projects'),
      },
      {
        path: 'qrcode-management',
        name: 'QRCodeManagement',
        component: () =>
          import(/* webpackChunkName: "qrcode-management" */ '@/views/home/QRCodeManagement'),
      },
      {
        path: 'user-management',
        name: 'UserManagement',
        component: () =>
          import(/* webpackChunkName: "user-management" */ '@/views/home/UserManagement'),
      },
      {
        path: 'editor',
        name: 'Editor',
        component: () => import(/* webpackChunkName: "editor" */ '@/views/home/Editor'),
      },
    ],
  },
]

export default home
